<template>
  <div class="fade-in columns is-multiline result-container" ref="resultPage">

    <!-- Header -->
    <div class="column is-12">
      <!-- <button class="button test-button" @click="makePDF()">PDF</button> -->
      <div class="columns">
        <div class="column is-3 no-padding">
          <div class="flex-center">
            <span class="targets-back flex-center" style="text-align: center;" @click="$emit('goTo', 'targets')">
              <icon class="tiny-svg fill-gray flex" name="arrow-left"></icon>
              {{$t('results.backButtonLabel')}}
            </span>
          </div>
        </div>
        <div class="column is-6">
          <div class="goals-header">
            <!-- <h1>{{$t('results.pageTitle')}}</h1> -->
          </div>
        </div>
        <div class="column is-3">

        </div>
      </div>
    </div>

    <!-- Result wheel -->
    <div class="column is-12 flex-justify-content-center" ref="resultWheel">
      <div class="result-wheel">
        <wheel :view="currentState" ref="wheel"></wheel>
      </div>
    </div>

    <!-- Targets -->
    <div class="column is-12 is-centered">
      <div class="columns">
        <div class="column is-12">
          <div v-for="goal in getSelectedScenario.goals" :key="goal.key" v-show="getSelectedScenario.goals && goal.targets && goal.targets.filter(target => target.selected).length > 0" class="columns is-multiline is-centered flex-justiy-content-center">
            <div class="column is-9">
              <div class="columns">
                <div class="column">
                  <h2 style="padding-left: 5px;">{{getGoalInfo(goal)}}</h2>
                </div>
              </div>
            </div>
            <div v-for="target in goal.targets" v-show="goal.selected && goal.targets && target.selected" :key="target.displayCode" class="column is-9 result-row">
              <div class="columns">
                <div class="column is-1">
                  <div>
                    <icon v-if="target.goalCode" class="large-svg sdg-target-icons goal-selected" :class="['goal-color-' + target.goalCode, {'disabled-target': !target.action || !target.indicator}]" :name="target.displayCode"></icon>
                  </div>
                </div>
                <div class="column is-11">
                  <div class="columns is-multine">
                    <div class="column is-1 target-column-space-max semi-bold">
                      {{target.displayCode}}
                    </div>
                    <div class="column" v-html="target.description"></div>
                  </div>
                  <div class="columns">
                    <div class="column is-1 target-column-space-max"></div>
                    <div class="column is-4 target-input-label">
                      <div class="flex-align-start">
                        <icon class="tiny-svg fill-primary" name="actions"></icon>
                        <span class="semi-bold" v-if="target.action === '' || target.action === null">{{$t('targets.actionSummaryLabelNon')}}</span>
                        <span v-else class="semi-bold">{{target.action}}</span>
                      </div>
                    </div>
                    <div class="column is-4 target-input-label">
                      <div class="flex-align-start">
                        <icon class="small-svg fill-primary" name="flag"></icon>
                        <span class="semi-bold" v-if="target.indicator === '' || target.indicator === null">{{$t('targets.indicatorSummaryLabelNon')}}</span>
                        <span v-else class="semi-bold">{{target.indicator}}</span>
                      </div>
                    </div>
                    <div class="column is-3 target-input-label">
                      <div class="flex-align-center">
                        <icon class="medium-flat-svg flex-center" :name="'effect' + target.effect"></icon>
                        <span class="semi-bold ">{{translateSlider(target.effect)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import wheel from './../shared/sdg-wheel/sdg-wheel-result.vue'

export default {
  name: 'results',
  props: {
    currentState: {
      type: String
    }
  },
  components: {
    wheel
  },
  data () {
    return {
      showFeedback: false
    }
  },
  computed: {
    ...mapGetters({
      createPDF: 'getCreatePDF',
      getGoalList: 'getGoalList',
      getSelectedScenario: 'getSelectedScenario'
    })
  },
  methods: {
    ...mapActions({
      setPDF: 'setPDF',
      setCreatePDF: 'setCreatePDF',
      setShowPdfModal: 'setShowPdfModal'
    }),
    translateSlider (effect) {
      let effectLabel = null
      switch (effect) {
        case -2:
          effectLabel = this.$t('targets.targetEffect-2')
          break
        case -1:
          effectLabel = this.$t('targets.targetEffect-1')
          break
        default:
        case 0:
          effectLabel = this.$t('targets.targetEffect0')
          break
        case 1:
          effectLabel = this.$t('targets.targetEffect1')
          break
        case 2:
          effectLabel = this.$t('targets.targetEffect2')
          break
        case 3:
          effectLabel = this.$t('targets.targetEffect3')
          break
      }
      return effectLabel
    },
    getGoalInfo (goal) {
      let goalString = this.getGoalList.filter(filteredGoal => Number(filteredGoal.code) === Number(goal.code) && goal.selected)[0]

      if (goalString) {
        return goalString.code + ': ' + goalString.title
      } else {
        return ''
      }
    },
    async makePDF () {
      this.setShowPdfModal(true)
      this.setCreatePDF(false)
      try {
        await this.setPDF(this.$refs.wheel.jsWheel.getSvgText())

        setTimeout(() => {
          this.setShowPdfModal(false)
        }, 1500)
      } catch (err) {
        throw new Error(err)
      }
    }
  },
  watch: {
    createPDF (val) {
      if (val) {
        this.makePDF()
      }
    }
  }
}
</script>
